import * as fromModal from '../_reducers/modal.reducer';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModalState} from '../_reducers/modal.reducer';


export const selectModalState = createFeatureSelector<ModalState>(fromModal.modalFeatureKey);
export const selectOpenModal = createSelector(selectModalState, state => state);
export const selectCloseModal = createSelector(selectModalState, ({component}) => !component);
export const modalOpenPayloadSelector = createSelector(selectModalState, state => state.openPayload);
export const modalClosePayloadSelector = createSelector(selectModalState, state => state.closePayload);
